// The signed-in person's account details after a change: a new object, the original untouched.
export type UserDoc = { email?: string, firstName?: string, lastName?: string };

// Only the fields given are replaced, so anything else the server sent about the user is kept. With no user cached
// there is nothing to patch.
export const withUserFields = <T extends UserDoc>(user: T | null | undefined, fields: UserDoc) =>
    user ? { ...user, ...fields } : user;
